import React from 'react';
import { ThemeProvider, Toaster } from '@elva/ui';

export function AppProviders({ children }: { children: React.ReactNode }) {
  return (
    <ThemeProvider defaultThemeId="neue" persist storageKey="elva-theme-ai-receptionist">
      <Toaster position="bottom-right">{children}</Toaster>
    </ThemeProvider>
  );
}
